//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.InspectionTemplateOptionsQuery
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import com.wintermar.inspection.graphql.type.adapter.InspectionAnswerType_ResponseAdapter
import kotlin.Any
import kotlin.Int
import kotlin.String
import kotlin.collections.List

public object InspectionTemplateOptionsQuery_ResponseAdapter {
  public object Data : Adapter<InspectionTemplateOptionsQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("inspectionTemplateOptions")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplateOptionsQuery.Data {
      var _inspectionTemplateOptions: List<InspectionTemplateOptionsQuery.InspectionTemplateOption>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _inspectionTemplateOptions = InspectionTemplateOption.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplateOptionsQuery.Data(
        inspectionTemplateOptions = _inspectionTemplateOptions ?: missingField(reader, "inspectionTemplateOptions")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplateOptionsQuery.Data,
    ) {
      writer.name("inspectionTemplateOptions")
      InspectionTemplateOption.obj().list().toJson(writer, customScalarAdapters, value.inspectionTemplateOptions)
    }
  }

  public object InspectionTemplateOption : Adapter<InspectionTemplateOptionsQuery.InspectionTemplateOption> {
    public val RESPONSE_NAMES: List<String> = listOf("label", "answerType", "order", "id")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplateOptionsQuery.InspectionTemplateOption {
      var _label: String? = null
      var _answerType: InspectionAnswerType? = null
      var _order: Int? = null
      var _id: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _label = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _answerType = InspectionAnswerType_ResponseAdapter.fromJson(reader, customScalarAdapters)
          2 -> _order = IntAdapter.fromJson(reader, customScalarAdapters)
          3 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplateOptionsQuery.InspectionTemplateOption(
        label = _label ?: missingField(reader, "label"),
        answerType = _answerType ?: missingField(reader, "answerType"),
        order = _order ?: missingField(reader, "order"),
        id = _id ?: missingField(reader, "id")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplateOptionsQuery.InspectionTemplateOption,
    ) {
      writer.name("label")
      StringAdapter.toJson(writer, customScalarAdapters, value.label)

      writer.name("answerType")
      InspectionAnswerType_ResponseAdapter.toJson(writer, customScalarAdapters, value.answerType)

      writer.name("order")
      IntAdapter.toJson(writer, customScalarAdapters, value.order)

      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)
    }
  }
}
